export default
function Title({ title }) {


    return (
        <div className="title-container">
            <h3>{title}</h3>
        </div>
    )
}